function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import methods from './methods';
import dayjs from 'dayjs';
export default {
  data: function data() {
    return {
      sDialogShow: false,
      dayjs: dayjs,
      complexQueryConfig: [],
      customShowList: [],
      showModal: false,
      modalStatus: false,
      dataGridLoad: false,
      comModelProps: null,
      comModel: null,
      modelShowFields: null,
      dataGridColumns: [],
      gridData: [],
      queryFields: [],
      queryFieldsZH: [],
      allqueryFields: [],
      hiddenQueryFields: [],
      filterFields: {},
      pageNo: 1,
      pageSize: 10,
      pageSizeOpts: [10, 20, 50, 100],
      labelWidth: 120,
      totalNum: 0,
      // 排序字段
      orderKey: [],
      // 排序类别（asc，desc）
      orderType: [],
      quickFilter: [],
      batch_select: [],
      multiColSetShow: false,
      column: [],
      slotColumn: [],
      // 操作
      funcAuth: [],
      showOper: true,
      hasRowOper: false,
      headOper: [],
      headOperBatch: [],
      rowOper: [],
      rowOperBatch: [],
      iframeUrl: '',
      iframeComponent: '',
      gridExportOptStatus: false,
      gridExportDataStatus: false,
      gridExportDataRequestParams: null,
      gridDataRequestParams: null,
      gridPrintOptStatus: false,
      gridPrintDataStatus: false,
      gridPrintDataRequestParams: null,
      modalId: '',
      modalTitle: '',
      modalWidth: 1000,
      modalHeight: 600,
      searchShow: false,
      pageSearch: true,
      showCheckbox: false,
      loading: true,
      dataGridId: '',
      clearCache: '',
      browsePerm: true,
      dataGridWidth: 0,
      dataGridHeight: -1,
      searchType: '01', // 查询控件 01:普通 02:简单,
      errorMsg: '',
      dbType: '',
      exportMaxCount: 0,
      returnParams: {},
      showDicManage: false,
      openDicModal: false,
      dicModalTitle: '字典代码管理',
      isDefaultTab: this.$route.query && this.$route.query.isDefaultTab ? this.$route.query.isDefaultTab : '',
      currentFilter: '',
      asyncExportTotal: 0,
      containSubordinate: '',
      startTime: null,
      renderData: [], // 当前渲染的部分数据
      currentStart: 0, // 当前渲染数据的起始索引
      isLoading: false, // 加载状态锁（防重复加载）
      noMoreData: false, // 是否加载完所有数据
      scrollThreshold: 40, // 距离底部50px触发加载
      scrollContainer: null, // 存储Table内部滚动容器
      dialogMark: '', //'resource_all',
      paramsDialog: {},
      operObjWidth: 100,
      autoGridHeight: 440 // 未配置高度时的自适应高度
    };
  },

  mixins: [methods],
  computed: {
    // 是否显示「自定义查询」入口：prop 优先，其次模型配置
    showCustomQuery: function showCustomQuery() {
      // if (this.enableCustomQuery) {
      //   return true
      // }
      var cfg = this.comModelProps && this.comModelProps.iscustomShow;
      return cfg === '1' || cfg === true;
    },

    // 传给自定义查询组件的业务标识
    customQueryMark: function customQueryMark() {
      return this.gridMark || this.funcMark || this.comModel && this.comModel.mark || '';
    },

    // 列表高度：配置了高度走配置，未配置则自适应
    gridHeight: function gridHeight() {
      // 外部传入的高度优先
      if (this.externalHeight !== null && this.externalHeight !== undefined && this.externalHeight !== '') {
        return this.externalHeight;
      }
      // 配置了有效高度则走配置
      var configHeight = Number(this.dataGridHeight);
      if (!isNaN(configHeight) && configHeight > 0) {
        return configHeight;
      }
      // 未配置则自适应
      return this.autoGridHeight;
    }
  },
  methods: {
    // 计算列表自适应高度（撑满剩余可视区域）
    calcAutoGridHeight: function calcAutoGridHeight() {
      var _this = this;

      this.$nextTick(function () {
        var wrapper = _this.$refs.scrollWrapper;
        if (!wrapper || !wrapper.getBoundingClientRect) {
          return;
        }
        var top = wrapper.getBoundingClientRect().top;
        var bottomReserve = 70; // 预留分页区域及底部间距
        var height = window.innerHeight - top - bottomReserve;
        if (height < 200) {
          height = 200;
        }
        _this.autoGridHeight = height;
      });
    },
    plog: function plog(title, endtime, starttime) {
      if (!starttime) starttime = this.startTime;
      console.log('[\u6027\u80FD] ' + title + ': ' + (endtime - starttime).toFixed(2) + 'ms');
    },
    query_grid_data: function query_grid_data(pageNo, Tag) {
      var _this2 = this;

      this.renderData = [];
      this.currentStart = 0;
      this.startTime = performance.now();
      console.log(this.$refs, '[\u6027\u80FD] \u5F00\u59CB\u67E5\u8BE2: Tag = ' + (Tag || '未定义') + ', pageNo=' + (pageNo || this.pageNo) + ', pageSize=' + this.pageSize);
      this.loading = true;
      if (pageNo) {
        this.pageNo = pageNo;
      }
      var params = this.getGridRequestParams(Tag == 'cx' ? Tag : this.searchType === '03' ? true : Tag);
      console.log(this.complexQueryConfig, 'complexQueryConfig', params);
      this.$emit('returnParams', params);
      this.$store.dispatch('postRequest', {
        url: '/bsp-com/com/datagrid/getQueryPageData',
        params: params
      }).then(function (resp) {
        if (resp.success) {
          _this2.plog('数据接收耗时', performance.now());
          var renderStart = performance.now();
          var onRenderComplete = function onRenderComplete() {
            _this2.plog('渲染耗时', performance.now(), renderStart);
            _this2.plog('总耗时', performance.now());
          };

          // 回调
          _this2.$emit('returnParamsSuccess', params, resp, _this2.returnParams);
          if (_this2.beforeRender) {
            _this2.beforeRender(resp).then(function (data) {
              if (data.success) {
                _this2.initRenderData(data.rows, data.total, onRenderComplete);
              }
            });
          } else {
            _this2.initRenderData(resp.rows, resp.total, onRenderComplete);
          }

          //分组统计
          if (_this2.comModel.groupStat && _this2.comModel.groupStatField && resp.group && _this2.quickFilter) {
            try {
              _this2.quickFilter[0].forEach(function (qf) {
                //基于分组字段统计
                if (!qf.groupStatType || qf.groupStatType == '0') {
                  var statFields = qf.groupStatField.split('|');
                  var statValues = qf.groupMatchValue.split('|');
                  qf.groupNum = 0;
                  for (var i = 0; i < statFields.length; i++) {
                    var statField = statFields[i];
                    var statValue = statValues[i];
                    if (resp.group[statField] && resp.group[statField][statValue]) {
                      qf.groupNum += resp.group[statField][statValue];
                    }
                  }
                }

                //基于过滤脚本统计
                else if (qf.groupStatType == '1' && resp.groupFilter) {
                    var groupMark = qf.mark;
                    qf.groupNum = resp.groupFilter[groupMark] || 0;
                  }
              });
            } catch (e) {
              console.log('分组统计异常：', e);
            }
          }

          //异步下载
          if (resp.asyncExportTotal) {
            _this2.asyncExportTotal = resp.asyncExportTotal;
          }
        }
      });
    },
    getGridRequestParams: function getGridRequestParams(Tag) {
      var _this3 = this;

      var params = {
        modelId: this.comModel.mark,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        browsePerm: this.browsePerm
      };
      var searchCondis = [];
      var condis = this.build_query_condis(Tag);
      var filterCondis = this.build_filter_condis();
      if (filterCondis.length > 0) {
        searchCondis = searchCondis.concat(filterCondis);
      }
      if (condis.length > 0) {
        searchCondis = searchCondis.concat(condis);
      }
      if (searchCondis.length > 0) {
        params.condis = JSON.stringify(searchCondis);
      }
      var quickFilterSql = this.get_quick_filter();
      if (quickFilterSql && quickFilterSql !== '') {
        params.quickFilterSql = quickFilterSql;
      }

      var _orderKey = [];
      if (this.orderKey.length > 0) {
        this.orderKey.forEach(function (item) {
          var _key = _this3.chineseSort[item];
          if (_key) {
            _orderKey.push(_key);
          } else {
            _orderKey.push(item);
          }
        });
      }

      params.sortName = _orderKey.join(',');
      params.sortType = this.orderType.join(',');
      if (Object.keys(this.extendParams).length > 0) {
        params.extendParams = JSON.stringify(this.extendParams);
      } else if (Object.keys(this.params).length > 0) {
        var paramsAll = Object.assign(this.$route.query, this.params);
        params.extendParams = JSON.stringify(paramsAll);
      } else {
        params.extendParams = JSON.stringify(this.$route.query);
      }
      return params;
    },
    initRenderData: function initRenderData(rowData, total, onComplete) {
      this.gridData = rowData;
      this.totalNum = total;
      var disableFieldsStart = performance.now();
      var disableFields = this.modelShowFields.filter(function (item) {
        return item.attachProps && JSON.parse(item.attachProps) && JSON.parse(item.attachProps)._disabled;
      });
      this.plog('处理禁用字段', performance.now(), disableFieldsStart);
      var _disabledStart = performance.now();
      if (this.gridData && this.gridData.length > 0) {
        this.gridData.forEach(function (item) {
          disableFields.forEach(function (obj) {
            var props = JSON.parse(obj.attachProps);
            if (props._disabledValue == item[obj.name.toLowerCase()]) {
              item._disabled = true;
            }
          });
        });
      }
      this.plog('处理附加属性', performance.now(), _disabledStart);
      this.batch_select = [];
      this.loading = false;
      this.$nextTick(function () {
        if (onComplete) onComplete();
      });
      // 3. 加载第一批数据
      // this.loadMoreData();
      // this.initScrollContainer()
    },

    // 2. 核心：获取Table内部滚动容器（ivu-table-overflowY）
    initScrollContainer: function initScrollContainer() {
      var _this4 = this;

      setTimeout(function () {
        // 等待Table渲染完成后再获取滚动容器
        var collection = document.getElementsByClassName("ivu-table-overflowY");
        console.log(collection, "成功绑定Table滚动容器");
        if (collection.length > 0) {
          _this4.scrollContainer = collection[0];
          // 绑定滚动事件
          _this4.scrollContainer.addEventListener("scroll", _this4.handleTableScroll);
          _this4.resetScrollTop();
          console.log("成功绑定Table滚动容器");
        } else {
          // 兜底：若首次获取失败，延时重试（兼容Table渲染慢的场景）
          setTimeout(function () {
            var retryCollection = document.getElementsByClassName("ivu-table-overflowY");
            if (retryCollection.length > 0) {
              _this4.scrollContainer = retryCollection[0];
              _this4.scrollContainer.addEventListener("scroll", _this4.handleTableScroll);
            } else {
              console.warn("未找到Table滚动容器：ivu-table-overflowY");
            }
          }, 200);
        }
      }, 2000);
    },


    // 3. 监听Table滚动容器的滚动事件
    handleTableScroll: function handleTableScroll() {
      // console.log(this.loading , this.noMoreData,'this.loading || this.noMoreData')
      if (this.loading || this.noMoreData) return; // 防重复加载

      var container = this.scrollContainer;
      // 计算滚动容器的滚动距离：总高度 - 滚动距离 - 可视高度 = 剩余未滚动高度
      var remainingHeight = container.scrollHeight - container.scrollTop - container.clientHeight;
      // console.log(remainingHeight , this.scrollThreshold,'remainingHeight < this.scrollThreshold')
      // 滚动到接近底部（剩余高度 < 阈值），触发加载
      if (remainingHeight < this.scrollThreshold) {
        this.loadMoreData();
      }
    },


    // 4. 加载下一批数据（从全量数据中截取）
    loadMoreData: function loadMoreData() {
      var _this5 = this;

      this.loading = false;
      // 模拟加载延迟（真实接口可去掉）
      setTimeout(function () {
        // 计算本次加载的结束索引
        var endIndex = _this5.currentStart + 100;
        // 截取要追加的部分数据
        var newData = _this5.gridData.slice(_this5.currentStart, endIndex);

        // 追加到渲染列表（只渲染部分数据）
        _this5.renderData = [].concat(_toConsumableArray(_this5.renderData), _toConsumableArray(newData));
        // console.log(this.renderData,'this.renderData')
        // 更新起始索引
        _this5.currentStart = endIndex;

        // 判断是否加载完所有数据
        if (_this5.renderData.length >= _this5.gridData.length) {
          _this5.noMoreData = true;
        } else {
          _this5.noMoreData = false;
        }
        _this5.loading = false;
      }, 200);
    },

    // 4. 重置滚动容器到顶部
    resetScrollTop: function resetScrollTop() {
      var _this6 = this;

      this.$nextTick(function () {
        // 确保DOM更新后再操作滚动条
        if (_this6.scrollContainer) {
          _this6.scrollContainer.scrollTop = 0; // 滚动条置顶
        } else {
          // 兜底：重新获取滚动容器并置顶
          var collection = document.getElementsByClassName("ivu-table-overflowY");
          if (collection.length > 0) {
            _this6.scrollContainer = collection[0];
            _this6.scrollContainer.scrollTop = 0;
          }
        }
        // this.initScrollContainer()
      });
    },
    refreshGrid: function refreshGrid(pageNo) {
      this.query_grid_data(pageNo);
    },
    get_quick_filter: function get_quick_filter() {
      var filterSql = [];
      this.quickFilter.forEach(function (filters) {
        var orSql = [];
        filters.forEach(function (item) {
          if (item.isDefault === '1') {
            if (item.filterSql) {
              orSql.push(item.filterSql);
            }
          }
        });
        if (orSql.length > 0) {
          filterSql.push(orSql.join(' or '));
        }
      });
      return filterSql.join(' and ');
    },

    // condis参数
    build_query_condis: function build_query_condis(Tag) {
      var _this7 = this;

      //console.log(Tag, 'Tag', Tag && Tag != 'cx')
      var queryParams = [];
      var queryFields = [];
      if (Tag && Tag != 'cx') {
        queryFields = this.complexQueryConfig.concat();
        queryFields.forEach(function (item) {
          if (item.fields && item.fields.length > 0) {
            item.fields.forEach(function (ele) {
              _this7.queryFields.forEach(function (filesChild) {
                filesChild.forEach(function (dd) {
                  if (ele.name == dd.name) {
                    dd = Object.assign(dd, ele);
                  }
                });
              });
            });
          }
        });
        this.$forceUpdate();
      } else if (Tag && Tag == 'cx') {
        var queryFieldsGj = [];
        var queryFieldsDefault = this.complexQueryConfig.concat();
        queryFieldsDefault.forEach(function (item) {
          if (item.fields && item.fields.length > 0) {
            item.fields.forEach(function (ele) {
              _this7.queryFields.forEach(function (filesChild) {
                queryFieldsGj.push(ele);
                filesChild.forEach(function (dd) {
                  if (ele.name == dd.name) {
                    dd = Object.assign(ele, dd);
                  }
                });
              });
            });
          }
        });
        queryFields = this.queryFields.concat([queryFieldsGj]);
        this.$forceUpdate();
      } else {
        queryFields = this.queryFields.concat();
      }
      var _that = this;
      _that.containSubordinate = '';
      if (this.hiddenQueryFields.length > 0) {
        var hiddenFields = [];
        var req = Object.assign({}, this.$route.query, this.params);
        var temValue = {
          user: this.$store.getters.sessionUser,
          req: req
        };
        this.hiddenQueryFields.forEach(function (field) {
          var item = Object.assign({}, field);
          var defaultValue = item.defaultValue ? item.defaultValue.trim() : '';
          var tem = _that.template(defaultValue, temValue);
          if (tem !== '') {
            item.searchValue = tem;
          }
          if (item.startDefault) {
            item.start = _that.template(item.startDefault.trim(), temValue);
          }
          if (item.endDefault) {
            item.end = _that.template(item.endDefault.trim(), temValue);
          }
          hiddenFields.push(item);
        });
        if (hiddenFields.length > 0) {
          queryFields.push(hiddenFields);
        }
      }
      queryFields.forEach(function (itemChild) {
        var fields = Tag && Tag != 'cx' ? itemChild.fields : itemChild;
        fields.forEach(function (item) {
          if (item.controlTypeName && (item.controlTypeName == '09' || item.controlTypeName == '10')) {
            _that.containSubordinate = item && item.containSubordinate ? item.containSubordinate : '';
          }

          if (item.opName === 'between') {
            if (item.start) {
              var param = {
                name: item.name,
                op: '>=',
                value: item.start,
                valueType: item.valueType
              };
              queryParams.push(param);
            }
            if (item.end) {
              var endDefault = item.end;
              if (endDefault.length === 16 && item.valueType === 'datetime') {
                endDefault += ':59';
              } else if (endDefault.length === 14 && item.valueType === 'datetime') {
                endDefault += ':59:59';
              }
              var _param = {
                name: item.name,
                op: '<=',
                value: endDefault,
                valueType: item.valueType
              };
              queryParams.push(_param);
            }
          } else if (item.searchValue instanceof Array) {
            if (item.searchValue.length > 0) {
              var _param2 = {
                name: item.name,
                op: 'dicmultiple',
                value: item.searchValue.join(','),
                valueType: item.valueType
              };
              queryParams.push(_param2);
            }
          } else if (item.searchValue) {
            var _param3 = {
              name: item.name,
              op: item.opName,
              value: item.searchValue,
              valueType: item.valueType
            };
            if (item.isDicMultiple) {
              _param3.op = 'dicmultiple';
            }
            queryParams.push(_param3);
          }
        });
      });
      this.params.containSubordinate = this.containSubordinate;
      return queryParams;
    },
    build_filter_condis: function build_filter_condis() {
      var filterFields = {};
      Object.assign(filterFields, this.filterFields);
      var queryParams = [];
      for (var key in filterFields) {
        var valSize = filterFields[key].length;
        if (valSize > 0) {
          var op = '=';
          if (filterFields[key].length > 1) {
            op = 'dicmultiple';
          }
          var param = {
            name: key,
            op: op,
            value: filterFields[key].join(','),
            valueType: 'string'
          };
          queryParams.push(param);
        }
      }
      return queryParams;
    },
    on_batch_select: function on_batch_select(data) {
      // 批量选择
      this.batch_select = data;
    },
    isAuth: function isAuth(data) {
      if (data && data !== '') {
        return false;
      }
      return true;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/mixins/data.js
// module id = 5
// module chunks = 0